<template>
    <div class="d-flex aside-width menu">
        <!-- <div class="react-left ml-4 react-l-s">
            <span class="react-left"></span>
            <span class="text"></span>
        </div> -->
        <div class="react-left ml-3" :class="cur == index ? 'bg-color-blue' : ''" v-for="(item, index) in options"
            :key="item.router" @click="handleClick(index)">
            <span class="text">{{item.text}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: ['cur'],
    data() {
        return {
            options: [
                {
                    text: '气候',
                    router: 'weather'
                },
                {
                    text: '能源',
                    router: 'power'
                },
                {
                    text: '设备',
                    router: 'device'
                },
            ]
        }
    },
    methods: {
        handleClick: function(index) {
            this.$router.push(this.options[index].router)
        }
    }
}
</script>
<style lang="scss" scoped>
.menu {
    display: grid;
    grid-template-columns: repeat(3, 32%);
    grid-gap: 10px;

    .react-left {
        &.react-l-s {
            width: 500px;
            text-align: left;
        }

        font-size: 18px;
        // width: 300px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        transform: skewX(45deg);
        background-color: #0f1325;
        cursor: pointer;

        // .react-left {
        //     position: absolute;
        //     left: -25px;
        //     top: 0;
        //     height: 50px;
        //     width: 50px;
        //     background-color: #0f1325;
        //     transform: skewX(-45deg);
        // }

        .text {
            display: inline-block;
            transform: skewX(-45deg);
        }
    }
}
</style>